import React, {useEffect} from 'react'
import { makeStyles } from '@material-ui/core/styles';
import { Accordion, AccordionDetails, AccordionSummary, Typography } from '@material-ui/core'

import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import RenderComponentBasedOnBlock from './RenderComponentBasedOnBlock'

import useStyles from './styles';

const StepLevelBlocks = (props) => {

    const { blocks, selectedStep } = props;

    const classes = useStyles();

    useEffect(() => {

    }, [props.selectedStep])


    return (
        <React.Fragment>
            {
                selectedStep.blocks?.length > 0 ? selectedStep.blocks.map((block, index) => {
                    return (
                    <RenderComponentBasedOnBlock
                        key={`${block.name}_${index}`}
                        block={block}
                        {...props}
                    />)
                }) : <div>
                    <Typography>
                        No Blocks configured to display.
                    </Typography>
                </div>

            }
        </React.Fragment>
    )
}

export default StepLevelBlocks